import { createFileRoute } from '@tanstack/react-router'
import { KeySquare } from 'lucide-react'
import { z } from 'zod'
import { AccessScreen } from '@/screens/investigate/SCR-018-access'

export const Route = createFileRoute('/_app/w/$ws/access')({
  staticData: { screen: { id: 'SCR-018', title: 'Access graph', group: 'Investigate', perm: 'access.inspect', order: 9, description: 'Who can see what in this workspace, and through which grant.', icon: KeySquare } },
  validateSearch: z.object({
    memory: z.string().max(200).optional(),
    subject: z.string().max(200).optional(),
    limit: z.coerce.number().int().min(10).max(300).optional().catch(undefined),
  }),
  component: AccessScreen,
})
